// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3kyvl","tab":"Tabs_tab__1poKp","tabActive":"Tabs_tabActive__2gwmL"};